import type { Location } from 'app/redux/models/Location/Location';
import type { ICoords } from 'app/typings/location';
import type { IPictureForm } from 'app/typings/misc';

import type { ModifierType } from './autoInventory';
import type { ChannelManager } from './channelManagers';
import type { RateMode } from './rateModes';

type Insights = {
  id: number;
  tier: number;
  presenceRatio: number;
  value: number;
};

export enum HotelStatus {
  UNPUBLISHED = 'UNPUBLISHED',
  PUBLISHED = 'PUBLISHED',
  HIDDEN = 'HIDDEN',
}

export type IHotel = {
  id: number;
  name: string;
  countryId: number;
  groupId: number;
  insights: Insights;
  location: Location;
  contacts: string[];
  bookingUrl: string;
  experiencesValue: number;
  snoozeNotifications?: string | Date;
  roomCount?: number;
  updatedAt: string | Date;
  stars?: number;
  hotelAdminAccess: boolean;
  channelManager?: ChannelManager;
  stockScrapperEnabled: boolean;
  rateMode?: RateMode;
  pspId?: string;
  pspOnboardingDone: boolean;
  paymentReady: boolean;
  adyenAccountRef?: string;
  contactIds: number[];
  autoDiscountRate?: number;
  lastMinuteAutoDiscountRate?: number;
  lastMinuteAutoDiscountDays?: number;
  managerId?: number;
  stockScrapperBarModifierValue?: number;
  stockScrapperBarModifierType?: ModifierType;
  issuingActivated: boolean;
  parentHotelId?: number;
  isLegacy: boolean;
  slug: string;
  status: HotelStatus;
};

export type HotelDisclaimer = {
  id: number | null;
  text: string;
  startDate: string | null;
  endDate: string | null;
  temporaryId: number;
  priority: number;
  hotelId: number;
};

export type IPackage = {
  id: number;
  aliasForHotel: string;
  aliasForUser?: string;
  hotelName: string;
  hotelId: number;
  coverPicture: IPictureForm;
  sliderPicture: IPictureForm;
  pictures: IPictureForm[];
  coords: ICoords;
  rankingScore: number;
  updatedAt: string | Date;
  isNew: boolean;
  published: boolean;
  url: string;
};
